<div class="map-container"></div>
<ng-content />
